import {
    chakra, Flex, Text, Box, ListItem
} from '@chakra-ui/react';

import { ModalWrapper } from '../../../../../../../components/modal-wrapper';

export const wrapper = chakra(ModalWrapper, {
    label: 'introducing-new-courses-modal-wrapper',
    baseStyle: {
        flexDirection: 'column',
        padding: 0,
        overflow: 'hidden',
        border: 'none'
    }
});

export const container = chakra(Flex, {
    label: 'introducing-new-courses-modal-container',
    baseStyle: {
        border: '8px solid rgba(255, 255, 255, 0.5)',
        borderRadius: '20px'
    }
});

export const title = chakra(Text, {
    label: 'introducing-new-courses-modal-title',
    baseStyle: {
        fontSize: '52px !important',
        lineHeight: '110%',
        letterSpacing: '-2.2px'
    }
});

export const subTitle = chakra(Text, {
    label: 'introducing-new-courses-modal-sub-title',
    baseStyle: {
        color: '#004786',
        fontSize: '22px !important',
        fontWeight: 600,
        lineHeight: '160%',
        letterSpacing: '-0.5px',
        w: '100%',
        mt: '12px !important'
    }
});

export const infoWrapper = chakra(Flex, {
    label: 'introducing-new-courses-modal-info-wrapper',
    baseStyle: {
        color: '#001937',
        letterSpacing: '-0.5px',
        w: '90%',
        flexDirection: 'column',
        textAlign: 'start'
    }
});

export const infoText = chakra(Box, {
    label: 'introducing-new-courses-modal-info-text',
    baseStyle: {
        color: '#001937',
        fontSize: '17px !important',
        display: 'inline',
        letterSpacing: '-0.5px',
        lineHeight: '27.2px'
    }
});

export const listItem = chakra(ListItem, {
    label: 'introducing-new-courses-modal-list-item',
    baseStyle: { position: 'relative' }
});

export const listItemWrapper = chakra(Box, {
    label: 'introducing-new-courses-modal-list-wrapper',
    baseStyle: {
        position: 'relative',
        left: '-8px',
        top: '-3px'
    }
});

export const infoTextBold = chakra(infoText, {
    label: 'introducing-new-courses-modal-info-text-bold',
    baseStyle: { fontWeight: 700 }
});
